//const APIURL = 'https://qa-apis.herokuapp.com';
//const APIURL = 'http://66.97.45.67:5001';
const APIURL = process.env.VUE_APP_ROOT_API;


const globalFetch = async(endpoint, method = 'GET', body = {}, timeout = 30000, contentType) => {
    const resp = await fetchTimeout(APIURL + endpoint, method, timeout, body, contentType)
    const json = await resp.json()


    //debugger;
    if (
        //resp.status === 400 ||
        resp.status === 403 ||

        resp.status === 401 ||
        //json.message === 'Bad Credentials' ||
        json.message === 'invalid token ' ||
        json.message === 'jwt malformed '
    ) {
        localStorage.removeItem('token')
        localStorage.removeItem('perfil')

        //window.location.reload()

    }
    return { body: json, status: resp.status }
}

const fetchTimeout = (url, method, timeout, body, contentType) => {
    const myOptions = makeOptions(method, body, contentType)

    return Promise.race([
        fetch(url, myOptions),
        new Promise((resolve, reject) =>
            setTimeout(() => reject({ message: `timeout with ${timeout} miliseconds` }), timeout)
        )
    ]);
}

const makeOptions = (method, body, contentType = 'application/json') => {



        const token = localStorage.getItem('token')
        let myOptions = {

            method,
            headers: {
                'Access-Control-Allow-Origin': '*',

                'token': localStorage.getItem('token')

            }
        }

        if (contentType) myOptions.headers['Content-Type'] = contentType
        if (method !== 'GET' /*&& method !== 'DELETE'*/ ) { myOptions.body = JSON.stringify(body) }
        return myOptions
    }
    //Clients Management
exports.getAllClients = async() => await globalFetch('/clients')
exports.createNewClient = async(body) => await globalFetch(`/clients/`, 'POST', body)
exports.editClient = async(body, Id) => await globalFetch(`/clients/${Id}`, 'PUT', body)
exports.deleteClient = async(id) => await globalFetch(`/clients/${id}`, 'DELETE')

//User Management
exports.loguin = async(body) => await globalFetch('/auth', 'POST', body)

exports.logout = async() => await removeCredentials()


exports.getAllUsers = async() => await globalFetch('/users')
exports.createNewUser = async(body) => await globalFetch(`/users/`, 'POST', body)
exports.editUser = async(body, Id) => await globalFetch(`/users/${Id}`, 'PUT', body)
exports.deleteUser = async(id) => await globalFetch(`/users/${id}`, 'DELETE')

//categories Management
exports.getAllCategories = async() => await globalFetch('/categories')
exports.createNewCategory = async(body) => await globalFetch(`/categories/`, 'POST', body)
exports.editCategory = async(body, Id) => await globalFetch(`/categories/${Id}`, 'PUT', body)
exports.deleteCategory = async(id) => await globalFetch(`/categories/${id}`, 'DELETE')

//categories Management
exports.getAllQAs = async() => await globalFetch('/qa')
exports.createNewQA = async(body) => await globalFetch(`/qa/`, 'POST', body)
exports.editQA = async(body, Id) => await globalFetch(`/qa/${Id}`, 'PUT', body)
exports.deleteQA = async(id, body) => await globalFetch(`/qa/${id}`, 'DELETE', body)

//reports Management
exports.getAllReports = async(init, final) => await globalFetch(`/reports/${init}/${final}`)
exports.sendReport = async(body) => await globalFetch('/reports', 'POST', body)

exports.getCredentials = async() => await credentials();


const credentials = () => {
    //debugger;
    const token = localStorage.getItem('token')
    const perfil = localStorage.getItem('perfil')
        //const perfil2 = localStorage.getItem('perfil2')
    return { token, perfil }
}

const removeCredentials = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('perfil');
}

/**
 * Enviando un archivo
Los archivos pueden ser subido mediante el HTML de un elemento input <input type="file" />, FormData() y fetch().

var formData = new FormData();
var fileField = document.querySelector("input[type='file']");

formData.append('username', 'abc123');
formData.append('avatar', fileField.files[0]);

fetch('https://example.com/profile/avatar', {
  method: 'PUT',
  body: formData
})
.then(response => response.json())
.catch(error => console.error('Error:', error))
.then(response => console.log('Success:', response));
 *
 *
 *
 */